import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import HomeIcon from '@material-ui/icons/Home';
import CloseIcon from '@material-ui/icons/Close';
import { CommunityIcon, DivisionIcon } from 'global/components/PerformIcons';
import { ListItem, ListItemText, ListItemSecondaryAction, Button, Avatar, Typography } from '@material-ui/core';
import { get } from 'global/lib/lodash';
import useStyles from './TaskList.styles';
import { Loading, useScreen } from 'global/styles';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { getRealmName } from 'global/utils';
import { Text } from 'global/components/text';
import clsx from 'clsx';

export default function TaskListItem(props) {
  const isHeader = get(props, 'isHeader', false);
  const isClickable = get(props, 'isClickable', true);
  const { isMobile } = useScreen();
  const item = props.itemOverride || props.item;
  const filter = useSelector((state) => get(state, 'filter.tasks.list'));
  const DATEFORMAT = 'L'; // isMobile ? 'MM/DD/YYYY' : 'MM/DD/YYYY hh:mma';

  const [isHovered, changeIsHovered] = useState(false);
  const toggleHover = (bool) => {
    if (isHeader) {
      changeIsHovered(bool);
    }
  };

  const status = get(filter, 'status', '').toLowerCase();
  const showOpen = status.indexOf('open') > -1;
  const showPending = status.indexOf('pending') > -1;
  const showClosed = status.indexOf('closed') > -1;
  const buttonsDisplayed = [showOpen, showPending, showClosed].filter((d) => d).length;

  const classes = useStyles({ isMobile, buttonsDisplayed });

  const destinationParams = get(item,'realm.id') ? `?realmId=${get(item,'realm.id')}` : '';
  const destination = get(props, 'destination', `/tasks/list/${get(item, 'id')}${destinationParams}`);
  const agingDate = get(item, 'oldestOpenTaskDatetime');

  const content = {
    realmType: get(item, 'realmTier', Loading),
    label: get(item, 'label', Loading),
    realmName: getRealmName(item),
    issueOpen: get(item, 'open', Loading),
    issuePending: get(item, 'pending', Loading),
    issueClosed: get(item, 'closed', Loading),

    agingDate: agingDate ? `${moment(agingDate).format(DATEFORMAT)}` : agingDate === null ? 'N/A' : Loading,
    updatedDate: get(item, 'updatedAt') ? `${moment(get(item, 'updatedAt')).format(DATEFORMAT)}` : Loading,
  };
  content.icon = content.realmType === 'division' ? <DivisionIcon /> : content.realmType === 'community' ? <CommunityIcon /> : <HomeIcon />;
  const dayDiff = Math.abs(moment(content.agingDate).diff(moment(), 'days'));
  content.timerClassName = dayDiff > 21 ? classes.redIcon : dayDiff > 7 ? classes.orangeIcon : classes.greyIcon;

  return (
    <ListItem
      component={isClickable ? Link : 'div'}
      to={isClickable ? destination : undefined}
      button={isClickable}
      key={item.id}
      onMouseEnter={() => {
        toggleHover(true);
      }}
      onMouseLeave={() => {
        toggleHover(false);
      }}
      className={clsx(classes.listItemRoot, isHeader && classes.listItemRootHeader)}
    >
      <Avatar className={classes.avatar}>{isHeader && isHovered ? <CloseIcon /> : content.icon}</Avatar>
      <ListItemText
        classes={{ primary: classes.listItemHeader, secondary: classes.listItemSecondary }}
        primary={content.realmName}
        secondaryTypographyProps={{ component: 'div' }}
        secondary={
          <div className={classes.row}>
            <div className={classes.updatedCol}>
              <Text type="secondarySub">Updated</Text>
              <Typography classes={{ root: classes.datesText }}>{content.updatedDate}</Typography>
            </div>
            <div className={classes.updatedCol}>
              <Text type="secondarySub">Oldest</Text>
              <Typography classes={{ root: classes.datesText }}>{content.agingDate}</Typography>
            </div>
          </div>
        }
      />
      <ListItemSecondaryAction classes={{ root: classes.listItemActions }}>
        {showOpen && (
          <Button classes={{ root: classes.issueBtnRoot, label: classes.issueBtnLabel }}>
            <Typography variant="inherit">{content.issueOpen}</Typography>
            <Typography variant="inherit">{'OPEN'}</Typography>
          </Button>
        )}
        {showPending && (
          <Button classes={{ root: classes.issueBtnRoot, label: classes.issueBtnLabel }}>
            <Typography variant="inherit">{content.issuePending}</Typography>
            <Typography variant="inherit">{'PENDING'}</Typography>
          </Button>
        )}
        {showClosed && (
          <Button classes={{ root: classes.issueBtnRoot, label: classes.issueBtnLabel }}>
            <Typography variant="inherit">{content.issueClosed}</Typography>
            <Typography variant="inherit">{'CLOSED'}</Typography>
          </Button>
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );
}
